'use client';

import type { ReactNode } from 'react';
import { HttpRequestDisplay } from '../../HITL/components/HttpRequestDisplay';
import type { HITLContentContext } from '../../tool-config-types';

export const renderHttpContent = (ctx: HITLContentContext): ReactNode => {
  if (!ctx.args) return null;
  return (
    <HttpRequestDisplay
      args={ctx.args}
      compact={false}
      isEditing={ctx.isEditing}
      onSave={ctx.onSave}
      onCancel={ctx.onCancel}
    />
  );
};
